import MainErrorCNIcon from '@/components/svgs/cn/main-error-cn';
import HeaderComponentCN from '../HeaderComponentCN';

const MainErrorCN = () => (
  <>
    <HeaderComponentCN main2ClassName="max-md:min-h-25 md:min-h-49" />
    <div className="flex flex-col items-center justify-center my-20 px-4">
      <MainErrorCNIcon className="w-26.5 h-26.5 shrink-0" />
      <p className="text-black1 mt-6 max-w-105 font-bold text-center uppercase">
        Down for Maintenance
      </p>
      <p className="text-black1 mt-4 max-w-105 text-center text-sm">
        We&apos;re upgrading our site to serve you better. Thanks for your understanding!
      </p>
    </div>
  </>
);

export default MainErrorCN;
